export const someAction = (state) => {}
import { api } from 'src/plugins/axios'
import { notify } from 'src/plugins/notify'
import { createQueryString } from 'src/utils'

export default {
  fetchCourses,
  fetchNYPirpStudentCompletion,
  generateNYPirpStudentCompletion,
  fetchAffiliateSchedule,
  generateCertificateReport,
  generateAffiliateSchedule,
  generateRecruiterReferral,
  generateAccountingReport,
  generateUnscheduledClassesReport,
  generateAddressValidationReport,
}

async function fetchCourses ({ commit, state }) {
  console.log('state', state)
  try {
    const { data: response } = await api.get('/reports/fetchCourses', {
      params: {
        LK_STATE_ID: state.studentCompletionForm.LK_STATE_ID
      }
    })
    const { success, payload } = response

    commit('setCourseStateList', payload)
    return response
  } catch (response) {
    notify.respond(response)
  }
}

async function fetchNYPirpStudentCompletion ({ commit, state }) {
  const { LK_STATE_ID, COURSE_ID, START_DATE, END_DATE } = state.studentCompletionForm
  try {
    commit('isLoading')
    const { data: response } = await api.get('/reports/fetchNYPirpStudentCompletion', {
      params: {
        LK_STATE_ID,
        COURSE_ID,
        START_DATE,
        END_DATE
      }
    })
    commit('doneLoading')
    const { success, payload } = response
    if (!success) throw response

    commit('setStudentCompletionList', payload.studentCompletionReport)
    commit('setStudentExceptionList', payload.studentExceptionList)

    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function generateNYPirpStudentCompletion ({ commit, state, getters }) {
  const reportData = state.studentCompletionList
  try {
    commit('isLoading')
    const { data: response } = await api.post('/reports/generateNYPirpStudentCompletion', { reportData })
    commit('doneLoading')
    return response
  } catch (response) {
    return response
  }
}

async function fetchAffiliateSchedule ({ commit, state, getters }) {
  try {
    commit('isLoading')
    const { data: response } = await api.get('/reports/fetchAffiliateSchedule', {
      params: state.affiliateScheduleForm
    })
    commit('doneLoading')
    const { success, payload } = response
    if (!success) throw response

    commit('setAffiliateScheduleList', payload)
    
    return response
  } catch (response) {
    return response
  }
}

async function generateAccountingReport ({ commit, state }, payload) {
  try {
    const { data: response } = await api.post('/reports/generateAccountingReport', payload)
    const { success } = response
    if (!success) throw response

    return response
  } catch (response) {
    return response
  }
}

async function generateCertificateReport ({ commit, state }) {
  try {
    const { data: response } = await api.post('/reports/generateCertificateReport', state.certficateReportForm)
    const { success } = response
    if (!success) throw response

    return response
  } catch (response) {
    return response
  }
}

async function generateAffiliateSchedule ({ commit, state, getters }) {
  const report = state.affiliateScheduleList
  try {
    const { data: response } = await api.post('/reports/generateAffiliateSchedule', report)
    const { success } = response
    if (!success) throw response

    return response
  } catch (response) {
    return response
  }
}

async function generateRecruiterReferral ({ commit, state, getters }) {
  const { START_DATE, END_DATE } = state.recruiterReferralForm
  try {
    const { data: response } = await api.get('/reports/generateRecruiterReferral', {
      params: {
        START_DATE,
        END_DATE
      }
    })
    return response
  } catch (response) {
    return response
  }
}

async function generateUnscheduledClassesReport({ commit, state }, payload) {
  try {
    const { data: response } = await api.get('/reports/generateUnscheduledClassesReport', {
      params: payload
    })
    const { success } = response
    if (!success) throw response

    return response
  } catch (response) {
    return response
  }
}

async function generateAddressValidationReport({ commit, state }, payload) {
  try {
    const { data: response } = await api.get('/reports/generateAddressValidationReport', {
      params: payload
    })
    return response
  } catch (err) {
    console.log('address validation report err', err)
    return null
  }
}
